import React from 'react'
import type { SourceMetricsWithTrendsData } from '../../../../../types/dataQuality'

interface SourceInfoCardsProps {
  metricsData?: SourceMetricsWithTrendsData
  source?: any
}

const SourceInfoCards: React.FC<SourceInfoCardsProps> = ({ metricsData, source }) => {
  const formatTimestamp = (timestamp?: string) => {
    if (!timestamp) return '2025-11-13 14:32 UTC'
    
    const date = new Date(timestamp)
    
    // Format: YYYY-MM-DD HH:MM UTC
    const year = date.getUTCFullYear()
    const month = String(date.getUTCMonth() + 1).padStart(2, '0')
    const day = String(date.getUTCDate()).padStart(2, '0')
    const hours = String(date.getUTCHours()).padStart(2, '0')
    const minutes = String(date.getUTCMinutes()).padStart(2, '0')
    
    return `${year}-${month}-${day} ${hours}:${minutes} UTC`
  }

  return (
    <div className="source-detail-cards">
      <div className="detail-card">
        <div className="detail-card-icon">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#6b7280" strokeWidth="2">
            <ellipse cx="12" cy="5" rx="9" ry="3"/>
            <path d="M3 5v14c0 1.66 4.03 3 9 3s9-1.34 9-3V5"/>
            <path d="M3 12c0 1.66 4.03 3 9 3s9-1.34 9-3"/>
          </svg>
        </div>
        <div className="detail-card-content">
          <div className="detail-card-label">Data Type</div>
          <div className="detail-card-value">
            {metricsData?.category_name || source?.category_name || 'Customer Data'}
          </div>
        </div>
      </div>

      <div className="detail-card">
        <div className="detail-card-icon">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#6b7280" strokeWidth="2">
            <circle cx="12" cy="12" r="10" />
            <polyline points="12 6 12 12 16 14" />
          </svg>
        </div>
        <div className="detail-card-content">
          <div className="detail-card-label">Last Ingestion</div>
          <div className="detail-card-value">
            {formatTimestamp(metricsData?.calculation_timestamp || source?.last_ingestion)}
          </div>
        </div>
      </div>

      <div className="detail-card">
        <div className="detail-card-icon">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="12" cy="12" r="10" stroke="#6C7280" strokeWidth="2"/>
            <circle cx="12" cy="12" r="6" stroke="#6C7280" strokeWidth="2"/>
            <circle cx="12" cy="12" r="2" fill="none" stroke="#6C7280" strokeWidth="2"/>
          </svg>
        </div>
        <div className="detail-card-content">
          <div className="detail-card-label">SLA Target</div>
          <div className="detail-card-value">
            {(metricsData?.metrics?.sla_health_score?.current_value ?? 99).toFixed(0)}
          </div>
        </div>
      </div>
    </div>
  )
}

export default SourceInfoCards
